import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import useStore from '../store';
import { formatCurrency, getCategoryName } from '../utils/colors';

function HUDPanel() {
  const { selectedNode, setSelectedNode } = useStore();
  
  if (!selectedNode) return null;
  
  // Safe deadline calculation
  const daysUntilDeadline = selectedNode.deadline 
    ? Math.ceil((new Date(selectedNode.deadline) - new Date()) / (1000 * 60 * 60 * 24))
    : null;
  
  // Extract source URL from various possible locations
  const sourceUrl = selectedNode.provenance?.source_url 
    || selectedNode.source_url 
    || selectedNode.url;
  
  return (
    <AnimatePresence>
      <motion.div
        className="hud-panel"
        initial={{ x: '100%' }}
        animate={{ x: 0 }}
        exit={{ x: '100%' }}
        transition={{ type: 'spring', stiffness: 300, damping: 30 }}
      >
        <div className="hud-panel-header">
          <h2>BID INTELLIGENCE</h2>
          <button className="close-btn" onClick={() => setSelectedNode(null)}>
            ×
          </button>
        </div>
        
        <div className="hud-panel-content">
          <div className="panel-section">
            <h3 className="bid-title">{selectedNode.title || selectedNode.scope}</h3>
            <div className="bid-meta">
              <span className="category-badge">{getCategoryName(selectedNode.category)}</span>
            </div>
          </div>
          
          <div className="panel-section">
            <label>Agency</label>
            <p className="agency-name">{selectedNode.agency}</p>
          </div>
          
          {/* Only show value if it exists */}
          {selectedNode.value && (
            <div className="panel-section">
              <label>Estimated Value</label>
              <div className="bid-value">{formatCurrency(selectedNode.value)}</div>
            </div>
          )}
          
          {/* Only show deadline if it exists */}
          {selectedNode.deadline && (
            <div className="panel-section">
              <label>Deadline</label>
              <div className="deadline-info">
                <p className="deadline-date">
                  {new Date(selectedNode.deadline).toLocaleDateString()}
                </p>
                {daysUntilDeadline !== null && (
                  <p className="deadline-countdown">
                    {daysUntilDeadline > 0 
                      ? `${daysUntilDeadline} days remaining` 
                      : 'Deadline passed'}
                  </p>
                )}
              </div>
            </div>
          )}
          
          <div className="panel-section">
            <label>Scope of Work</label>
            <p className="scope-text">{selectedNode.scope || 'No scope information available'}</p>
          </div>
          
          {selectedNode.description && (
            <div className="panel-section">
              <label>Description</label>
              <p className="description-text">{selectedNode.description}</p>
            </div>
          )}
          
          <div className="panel-section">
            <label>Location</label>
            <p className="location-text">
              {selectedNode.lat?.toFixed(4)}, {selectedNode.lon?.toFixed(4)}
            </p>
          </div>
          
          <div className="panel-actions">
            {/* Visit Source URL - opens agency's original bid page */}
            {sourceUrl && (
              <button 
                className="action-btn primary"
                onClick={() => window.open(sourceUrl, '_blank')}
              >
                VISIT SOURCE
              </button>
            )}
            
            <button className="action-btn secondary">TRACK THIS BID</button>
            <button className="action-btn secondary">FIND SIMILAR</button>
          </div>
        </div>
      </motion.div>
    </AnimatePresence>
  );
}

export default HUDPanel;